export default function checkoutPage() {
    return {
        // ====== DATA FROM BACKEND ======
        deliveries: window.CHECKOUT_DATA.deliveries ?? [],
        payments: window.CHECKOUT_DATA.payments ?? [],
        form: window.CHECKOUT_DATA.form ?? {},

        // ====== STATE ======
        delivery: null,
        payment: null,
        customerType: 'individual',

        // ====== INIT ======
        init() {
            this.resetDelivery()
            this.resetPayment()

            // реагируем ТОЛЬКО на событие
            window.addEventListener('city:changed', (e) => {
                this.reloadOptions(e.detail.id)
            })
        },

        // ====== COMPUTED ======
        get currentDelivery() {
            return this.deliveries.find(d => d.code === this.delivery) ?? null
        },

        // ====== ACTIONS ======
        resetDelivery() {
            this.delivery = this.deliveries[0]?.code ?? null
        },

        resetPayment() {
            this.payment = this.payments[0]?.code ?? null
        },

        async reloadOptions(cityId) {
            try {
                const res = await fetch(
                    Alpine.store('app').routes.checkout.options,
                    {
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            'Accept': 'application/json',
                        },
                    }
                )

                if (!res.ok) {
                    throw await res.json()
                }

                const data = await res.json()

                this.deliveries = data.deliveries ?? []
                this.payments = data.payments ?? []

                this.resetDelivery()
                this.resetPayment()
            } catch (e) {
                console.error('Checkout options reload failed', e)
            }
        },
    }
}
